import { render } from "./RecordView.vue?vue&type=template&id=4114ea40"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__